module.exports = __webpack_public_path__ + "static/img/200171.4ed4de49.png";